import * as d3 from 'd3'
export default {

  methods: {

    draw_Gantt() {

      // Timenow Line
      let timenow = this.timeline.scale(new Date(this.timeline.cutoff))
      let timeline = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.timeline.x}, ${this.table.y - this.table.lineHeight/2})`)

      timeline
      .append('line')
      .attr('x1', timenow).attr('y1', 0)
      .attr('x2', timenow).attr('y2', this.rawData.length * this.table.lineHeight )
      .attr('stroke', '#83D2F5').attr('opacity', .5).attr('stroke-width', 1)


      let charts = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.timeline.x}, ${this.table.y})`)

      this.gantt.forEach(st=> {
        if(st.type == 'ETA') this.draw_ETA(charts, st)
        if(st.type == 'SRD') this.draw_SRD(charts, st)
      })
    },
    

    draw_ETA(selection, st) {

      let y = 0
      let previous = 0
      this.rawData.forEach((d,i)=> {
        let status = this.legends.find(f=> f.code == d.STATUS).color

        selection
        .append('rect')
        .attr('x', d.early+.0).attr('y', y+6)
        .attr('width', (d.late - d.early == 0) ? 1 : d.late - d.early)
        .attr('height', 5).attr('fill', status)
        .attr('stroke', '#757575').attr('stroke-width', .5)
        .attr('opacity', .5)

        selection
        .append('line')
        .attr('x1', d.eta).attr('x2', d.eta)
        .attr('y1', y-20).attr('y2', y+20)
        .attr('stroke', '#F35E90').attr('stroke-width', 1).attr('opacity', 1)

        if (i>0) {
          selection
          .append('line')
          .attr('x1', previous).attr('x2', d.eta)
          .attr('y1', y-20).attr('y2', y-20)
          .attr('stroke', '#F35E90').attr('stroke-width', 1).attr('opacity', 1)
        }

        // ETA
        selection
        .append('circle')
        .attr('cx', d.eta).attr('cy', y+9-.5)
        .attr('r', 2.5).attr('fill', '#fff').attr('stroke', '#F35E90').attr('opacity', 1)

        selection
        .append('rect')
        .attr('x', d.eta-27).attr('y', y-14)
        .attr('width', 54).attr('height', 12)
        .attr('stroke', status).attr('stroke-width', .5).attr('fill', status).attr('fill-opacity', .2)

        selection
        .append('text')
        .attr('x', d.eta).attr('y', y-8.5 + 10*0.35)
        .attr('fill', st.tColor).attr('font-size', 10)
        .attr('text-anchor', 'middle')
        .text(d.ETA)

        // DEATA SRD
        let del_early = this.gmx_dateDiff(d.EARLY, d.ETA)
        let del_Late = this.gmx_dateDiff(d.LATE, d.ETA)
        
        selection // Delta Early
        .append('text')
        .attr('x', d.eta-30).attr('y', y-8.5 + 10*0.35)
        .attr('fill', this.gmx_deltaValue(del_early)).attr('font-size', 10)
        .attr('text-anchor', 'end')
        .text(del_early)

        selection // Delta Late
        .append('text')
        .attr('x', d.eta+30).attr('y', y-8.5 + 10*0.35)
        .attr('fill', this.gmx_deltaValue(del_Late)).attr('font-size', 10)
        .attr('text-anchor', 'start')
        .text(del_Late)

        previous = d.eta
        y = y + this.table.lineHeight
      })
    },


    draw_SRD(selection, st) {

      let y = 0
      this.rawData.forEach(d=> {

        let sch = this.timeline.scale(new Date(d[st.code]))
        selection
        .append('text')
        .attr('x', (st.code == 'EARLY') ? sch-4 : sch+4)
        .attr('y', y+7.5 + 10*0.35)
        .attr('fill', st.tColor).attr('font-size', 10)
        .attr('text-anchor', (st.code == 'EARLY') ? 'end' : 'start')
        .text(d[st.code])

        y = y + this.table.lineHeight
      })
    },

  }
}